<!-- 漏斗图配置 -->
<template>
  <div>
    <el-form-item label="文字内部">
      <el-switch v-model="main.activeOption.position"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'funnel',
  inject: ["main"]
}
</script>

<style>
</style>